import axios from "axios";

const getInstances = (page, params = {}) => {
  const encodedParams = Object.keys(params).reduce((acc, key) => {
    acc[key] = encodeURIComponent(params[key]);
    return acc;
  }, {});

  return axios.get("/api/zapi/instances", {
    params: {
      page,
      pageSize: 15,
      ...encodedParams,
    },
  });
};

const postInstance = (data) => {
  return axios.post("/api/zapi/instances", data);
};

const signInstance = (id, token) => {
  return axios.post("/api/zapi/subscription", { id, token });
};

const cancelInstance = (id, token) => {
  return axios.post("/api/zapi/cancel", { id, token });
};

export const requestsZAPI = {
  getInstances,
  postInstance,
  signInstance,
  cancelInstance,
};